import React, {Fragment} from 'react';
import {getApiUrl, getMemberImage} from "../service/Api";
import {GoogleMap, Marker} from "@react-google-maps/api";
import {getIcon} from "../service/Icon";

// Helper function to strip HTML tags and get plain text
const stripHtml = (html) => {
    if (!html) return '';

    // Create a temporary element to parse HTML
    const tmp = document.createElement('div');
    tmp.innerHTML = html;

    // Get text content and trim
    return tmp.textContent || tmp.innerText || '';
};

// Function to get category color (same as in CategoryList.js)
const getCategoryColor = (categoryId) => {
    const colorMap = {
        1: '#73456F',   // Nuklearmedizin
        2: '#108F64',   // Radiojodtherapie
        3: '#E0003A',   // Chirurgie
        4: '#F7CB24',   // Rehabilitation
        5: '#315596',   // Thermoablation
        6: '#b06c27',   // Endokrinologie
        7: '#5AA5DC',   // HNO
        8: '#108F64',   // Rehabilitation (alternative)
        9: '#FF6D00',   // Thermoablation (alternative)
        12: '#9C27B0',  // Endokrinologie (alternative)
        13: '#5AA5DC'   // HNO (alternative)
    };
    return colorMap[categoryId] || '#757575';
};

// SVG Category Icon Component
const CategoryIcon = ({ categoryId, title, size = 30 }) => {
    const color = getCategoryColor(categoryId);

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 30 30"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginRight: '8px', verticalAlign: 'middle' }}
        >
            <circle
                cx="15"
                cy="15"
                r="14"
                fill={color}
                strokeWidth="2"
            />
            <path
                d="M21.4 4.9c-.2.9-.4 1.7-.8 2.5-.3.8-.7 1.6-1.2 2.3-.5.7-1.2 1.3-2 1.7-.8.4-1.7.6-2.5.5-.9 0-1.7-.2-2.6-.5-.8-.3-1.6-.6-2.4-1-.4-.2-.7-.4-1.1-.6-.2-.1-.4-.2-.6-.4 0 0-.4-.2-.5-.4-.6-.5-1.1-1.1-1.4-1.9l-.1-.2C6.1 7 6 7 6 7c-.3.2-.6.3-.9.3-.1-.1-.3-.1-.4-.3-.2-.1-.3-.2-.4-.4.1.2.2.4.3.5.1.1.3.3.5.3h.6c.1 0 .3-.1.3-.1.1.4.3.7.5 1 .3.4.5.7.9 1 .2.2.6.5.6.5.2.1.4.2.5.4.4.2.8.5 1.1.7.8.4 1.6.8 2.5 1.1.4.1.9.3 1.3.4.5.1.9.1 1.4.1.9 0 1.9-.2 2.8-.6.4-.2.8-.5 1.2-.8.3-.3.6-.7.9-1.1.3-.4.5-.8.7-1.2.2-.4.4-.8.5-1.2.3-.9.4-1.8.5-2.7M6.6 8.5v.2c0 .2.1.3.1.6 0 .2.1.5.1.7.1.4.2.6.2.9 0 .3 0 .6.1 1 0 .3 0 .7.1 1V14c0 .4 0 .7-.1 1.1 0 .1-.1.2-.1.3 0 .1-.2.3-.2.3-.1.2-.3.3-.4.4-.6.4-1.2.7-1.7.8-.5.1-1 .2-1.3.2h-.5s.2 0 .5-.1.8-.1 1.3-.3c.5-.2 1.1-.4 1.6-.8.2-.2.5-.5.5-.8.1-.3.1-.7.1-1.1v-2.1c0-.7-.1-1.3-.1-1.8 0-1.1-.1-1.7-.1-1.7-.1 0-.1.1-.1.1m11.3 5.9c-.2-1.2-.4-1.7-.9-1.7-.5.1-1.1 1.2-1.3 1.6-.1.3-.3.7-.5.8-.3.1-.6 0-1 0-.3 0-.4 0-.8-.4-.2-.2-.4-.4-.6-.8-.7-1.1-1.3-1.7-1.8-1.6-.4.1-1.1.4-1.3 2-.1.6-.1 1.2 0 1.9.3 2.2 1.3 3.4 2 3.7.1 0 .2.1.3.1.4 0 .8-.3 1.2-.5l.6-.3c.3-.2.9-.5 1.2-.3.2.1.5.5.6.6.2.2.8.8 1.5-.6s.9-3.3.8-4.5M17.4 2.5c5 1.4 8.7 6.1 8.7 11.6 0 6.6-5.4 12-12 12-5.5 0-10.1-3.7-11.6-8.7 1.2 5.8 6.3 10.1 12.4 10.1 7 0 12.6-5.6 12.6-12.6 0-6.1-4.4-11.2-10.1-12.4M19 11.4c0 .3 0 .8.1 1.3 0 .6.1 1.2.1 1.9 0 .3.1.7.1 1 .1.3.2.7.3.9.2.2.4.5.7.6.3.2.6.3.9.5l.9.3.9.3c.5.1 1 .3 1.3.4.3.1.5.1.5.1s-.7-.1-1.8-.3c-.5-.1-1.2-.3-1.8-.5-.3-.1-.7-.3-1-.5-.3-.2-.6-.4-.9-.7-.2-.3-.3-.7-.4-1.1-.1-.4-.1-.7-.1-1.1v-1.9c0-1.1.1-1.6.1-1.6 0 .1 0 .1.1.4m-2.1-7.5h-.2c-.1 0-.8-.4-1.8.3-.3.2-.8.6-.8.6l-.2.2s-.1.1 0 .1 1-.7 1.3-.8.7-.2 1-.2c.3.1.4.1.5.1h.2c.1 0 .8-.2 1.2.1.4.3.5.6.7.8.2.2.3.3.5.4 0 0-.4-.5-.5-.8-.2-.3-.4-.8-1.2-.9-.4.1-.7.1-.7.1M18.9 5.8s.1.1 0 0c-.1 0-1-.6-1.9-.6h-1.1c-.3-.1-.7-.1-1 0s-1.3.2-1.9 0c-.2 0-.1-.1 0 0s1.1 0 1.8-.2.8-.1 1.3-.1 1.2.1 1.5.2c.2.1.6.2 1.3.7m-.4.3s.1 0 0 0c-.1.1-.8.4-2.3.3s-2.4-.6-2.4-.6-.1-.1 0 0c.1 0 1.6.3 2.5.4.9 0 1.8 0 2.2-.1"
                fill="#fff"
            />
        </svg>
    );
};

const VIEW_LETTER_A = 'letterA';
const VIEW_LETTER_B = 'letterB';

class MemberDetail extends React.Component {

    static defaultProps = {
        onClose: () => {
        },
        onNext: () => {
        },
        onPrev: () => {
        },
        handleSidebar: (open) => {
        },
        categories: [],
        member: {},
        selected: 0,
        total: 0,
        version: 'MOBILE'
    }

    constructor(props) {
        super(props);

        this.state = {
            activeView: VIEW_LETTER_A,
            sidebaropen: true,
            map: null,
            logoUrl: null,
            coverUrl: null,
            logoLoading: true,
            coverLoading: true,
            logoImageLoaded: false,
            direction: {
                origin: null,
                destination: null,
                travelMode: 'DRIVING',
                respoonse: null
            },
            layers: {
                firstLayer: [],
                secondLayer: []
            },
            accordion: {
                firstLayer: [],
                secondLayer: []
            }
        }

        this.xDown = null;
        this.yDown = null;
    }

    async componentDidMount() {
        document.addEventListener('touchstart', this.handleTouchStart, false);
        document.addEventListener('touchmove', this.handleTouchMove, false);
        this.bringToTop();
        this.handleLayers();
        await this.loadImages();
    }

    componentWillUnmount() {
        document.removeEventListener('touchstart', this.handleTouchStart, false);
        document.removeEventListener('touchmove', this.handleTouchMove, false);
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.member.member_id !== this.props.member.member_id) {
            this.setState({ logoImageLoaded: false });
            this.handleLayers();
            await this.loadImages();
        }
    }

    async loadImages() {
        this.setState({
            logoLoading: true,
            coverLoading: true
        });

        try {
            const [logoUrl, coverUrl] = await Promise.all([
                getMemberImage(this.props.member.member_id, 'member', 'logo'),
                getMemberImage(this.props.member.member_id, 'member', 'cover')
            ]);

            this.setState({
                logoUrl: logoUrl || `${getApiUrl()}imageout/null/lfallback.jpg?width=240&height=240`,
                coverUrl: coverUrl || `${getApiUrl()}imageout/null/fallback.jpg?width=1920&height=600`,
                logoLoading: false,
                coverLoading: false
            });
        } catch (error) {
            console.error('Error loading images for member:', this.props.member.member_id, error);
            this.setState({
                logoUrl: `${getApiUrl()}imageout/null/lfallback.jpg?width=240&height=240`,
                coverUrl: `${getApiUrl()}imageout/null/fallback.jpg?width=1920&height=600`,
                logoLoading: false,
                coverLoading: false
            });
        }
    }

    handleSidebarDesktop = (event) => {
        event.preventDefault();
        this.setState({
            sidebaropen: (this.state.sidebaropen !== true)
        }, () => {
            this.props.handleSidebar(this.state.sidebaropen);
        });

    }

    showLess = (e, layer, index) => {
        let layerIndex = [...this.state.accordion[layer]];
        const arrayIndex =  layerIndex.indexOf(index);

        if (arrayIndex > -1) { // only splice array when item is found
            layerIndex.splice(arrayIndex, 1); // 2nd parameter means remove one item only
        }

        this.setState({
            accordion: {
                ...this.state.accordion,
                [layer]: layerIndex
            }
        })
    }

    showMore = (e, layer, index) => {

        let layerIndex = [...this.state.accordion[layer]];
        layerIndex.push(index);

        this.setState({
            accordion: {
                ...this.state.accordion,
                [layer]: layerIndex
            }
        })
    }

    handleReadMoreRendering = () => {
        try {

            window.jQuery('.member-profile-card-accordion').each(function() {
                console.log(window.jQuery(this).find('.member-profile-card-body').height());
                if (window.jQuery(this).find('.member-profile-card-body').height() <= 300) {
                    window.jQuery(this).removeClass('member-profile-card-accordion');
                    window.jQuery(this).find('.readmore').hide();
                } else {
                    window.jQuery(this).find('.member-profile-card-body').css({
                        maxHeight: 300,
                        overflow: 'hidden'
                    })
                }
            })

        } catch (error) {

        }
    }

    handleLayers = () => {

        let firstLayer = [];
        let secondLayer = [];


        if (this.props.member.member_post_content && stripHtml(this.props.member.member_post_content).trim().length > 8) {
            firstLayer.push({
                title: 'Beschreibung',
                content: this.props.member.member_post_content
            })
        }

        if (this.props.member.member_diagnostic_services && stripHtml(this.props.member.member_diagnostic_services).trim().length > 8) {
            firstLayer.push({
                title: 'Diagnostische Leistungen',
                content: this.props.member.member_diagnostic_services
            })
        }

        if (this.props.member.member_work_hours !== null) {
            try {
                let workHours = JSON.parse(this.props.member.member_work_hours);

                if (
                    (workHours['Monday'] !== null && workHours['Monday'].length > 0) &&
                    (workHours['Tuesday'] !== null && workHours['Tuesday'].length > 0) &&
                    (workHours['Wednesday'] !== null && workHours['Wednesday'].length > 0) &&
                    (workHours['Thursday'] !== null && workHours['Thursday'].length > 0) &&
                    (workHours['Friday'] !== null && workHours['Friday'].length > 0) &&
                    (workHours['Saturday'] !== null && workHours['Saturday'].length > 0) &&
                    (workHours['Sunday'] !== null && workHours['Sunday'].length > 0)
                ) {

                    firstLayer.push({
                        direct: true,
                        title: 'Öffnungszeiten',
                        content: <Fragment>
                            <table width="100%" className="profile-table">
                                <tr>
                                    <td>Montag</td>
                                    <td>{(workHours['Monday'] === null || workHours['Monday'].length <= 0 ? '-': workHours['Monday'])}</td>
                                </tr>
                                <tr>
                                    <td>Dienstag</td>
                                    <td>{(workHours['Tuesday'] === null || workHours['Tuesday'].length <= 0 ? '-': workHours['Tuesday'])}</td>
                                </tr>
                                <tr>
                                    <td>Mittwoch</td>
                                    <td>{(workHours['Wednesday'] === null || workHours['Wednesday'].length <= 0 ? '-': workHours['Wednesday'])}</td>
                                </tr>
                                <tr>
                                    <td>Donnerstag</td>
                                    <td>{(workHours['Thursday'] === null || workHours['Thursday'].length <= 0 ? '-': workHours['Thursday'])}</td>
                                </tr>
                                <tr>
                                    <td>Freitag</td>
                                    <td>{(workHours['Friday'] === null || workHours['Friday'].length <= 0 ? '-': workHours['Friday'])}</td>
                                </tr>
                                <tr>
                                    <td>Samstag</td>
                                    <td>{(workHours['Saturday'] === null || workHours['Saturday'].length <= 0 ? '-': workHours['Saturday'])}</td>
                                </tr>
                                <tr>
                                    <td>Sonntag</td>
                                    <td>{(workHours['Sunday'] === null ||  workHours['Sunday'].length <= 0 ? '-': workHours['Sunday'])}</td>
                                </tr>
                            </table>
                        </Fragment>
                    })

                }


            } catch (error) {
            }
        }

        if (this.props.member.member_special_offers && stripHtml(this.props.member.member_special_offers).trim().length > 8) {
            firstLayer.push({
                title: 'Besondere Angebote',
                content: this.props.member.member_special_offers
            })
        }

        if (this.props.member.member_professional_career && stripHtml(this.props.member.member_professional_career).trim().length > 8) {
            secondLayer.push({
                title: 'Beruflicher Werdegang',
                content: this.props.member.member_professional_career,
                accordion: true,
                reference: React.createRef()
            })
        }
        if (this.props.member.member_qualifications && stripHtml(this.props.member.member_qualifications).trim().length > 8) {
            secondLayer.push({
                title: 'Qualifikationen',
                content: this.props.member.member_qualifications,
                accordion: true,
                reference: React.createRef()
            })
        }
        if (this.props.member.member_medical_presentations && stripHtml(this.props.member.member_medical_presentations).trim().length > 8) {
            secondLayer.push({
                title: 'Medizinische Vorträge',
                content: this.props.member.member_medical_presentations,
                accordion: true,
                reference: React.createRef()
            })
        }

        if (this.props.member.member_publications && stripHtml(this.props.member.member_publications).trim().length > 8) {
            secondLayer.push({
                title: 'Veröffentlichungen in medizinischen Fachzeitschriften & Büchern',
                content: this.props.member.member_publications,
                accordion: true,
                reference: React.createRef()
            })
        }

        this.setState({
            activeView: VIEW_LETTER_A,
            layers: {
                firstLayer: firstLayer,
                secondLayer: secondLayer
            }
        }, () => {

            this.handleReadMoreRendering();

        });

    }


    handleChangeView = (event, view) => {

        event.preventDefault();
        this.setState({
            activeView: view
        }, () => {
            this.handleReadMoreRendering();
        })

    }

    getTouches = (evt) => {
        return evt.touches ||             // browser API
            evt.originalEvent.touches; // jQuery
    }

    handleTouchStart = (evt) => {

        const firstTouch = this.getTouches(evt)[0];
        this.xDown = firstTouch.clientX;
        this.yDown = firstTouch.clientY;

    }

    handleTouchMove = (evt) => {

        if (!this.xDown || !this.yDown) {
            return;
        }

        var xUp = evt.touches[0].clientX;
        var yUp = evt.touches[0].clientY;

        var xDiff = this.xDown - xUp;
        var yDiff = this.yDown - yUp;

        if (Math.abs(xDiff) > Math.abs(yDiff)) {/*most significant*/
            if (xDiff > 0) {
                this.props.onNext();
            } else {
                this.props.onPrev();
            }
        } else {
            if (yDiff > 0) {
                /* down swipe */
            } else {
                /* up swipe */
            }
        }
        /* reset values */
        this.xDown = null;
        this.yDown = null;

    }

    bringToTop = () => {
        try {
            window.scrollTo(0, 0);
        } catch (error) {

        }
    }

    handlePrev = (event) => {
        event.preventDefault();
        this.bringToTop();
        this.props.onPrev();
    }

    handleNext = (event) => {
        event.preventDefault();
        this.bringToTop();
        this.props.onNext();
    }

    handleClose = (event) => {
        event.preventDefault();
        this.props.onClose();
    }

    handleDirectionForm = (event) => {
        event.preventDefault();

        this.handleOpenGoogleMaps(event, event.target.origin.value);

        this.setState({
            direction: {
                ...this.state.direction,
                origin: event.target.origin.value
            }
        })

    }

    handleOpenGoogleMaps = (event, address) => {
        event.preventDefault();

        const {member} = this.props;
        try {
            window.open('https://www.google.com/maps/dir/' + address + '/' + member.member_latitude + ',' + member.member_longitude + '/');
        } catch (error) {

        }
    }

    renderCategories = (categories) => {

        let list = [];

        categories.forEach(category => {
            let cat = this.props.categories.find((gCategory, index) => {
                if (parseInt(gCategory.category_id) === parseInt(category)) {
                    return true;
                }
                return false;
            });

            if (cat) {
                list.push(
                    <li key={category} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                        <CategoryIcon
                            categoryId={parseInt(cat.category_id)}
                            title={cat.category_title}
                            size={30}
                        />
                        {cat.category_title}
                    </li>
                )
            }

        })

        return list;
    }

    render() {

        const {
            member,
            selected,
            total
        } = this.props;

        let categories = member.member_category_ids.split(',');

        return (
            <div className="memberdetail-wrapper">
                <div className="memberdetail">
                    <div className="memberdetail-header">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-xs-3 col-md-3 memberdetail-nav-right">
                                    <button onClick={this.handlePrev} className="switch-button"><i className="fa fa-angle-left"/></button>
                                    {
                                        (this.props.version === 'DESKTOP')
                                        ?
                                            <button onClick={this.handleSidebarDesktop}>
                                                {
                                                    (this.state.sidebaropen === true) ? <><i className="fas fa-filter" /> Vollbild</>
                                                        : <><i className="fas fa-filter" /> Filterung</>
                                                }
                                            </button>
                                        :
                                            <></>
                                    }

                                </div>
                                <div className="col-xs-4 col-md-6 text-center">
                                    {(selected + 1)} von {total}
                                </div>
                                <div className="col-xs-5 col-md-3 text-right memberdetail-nav-right">
                                    <button onClick={this.handleClose} className="switch-button">
                                        <i className="fa fa-close"/>
                                    </button>
                                    <button onClick={this.handleNext} className="switch-button">
                                        <i className="fa fa-angle-right"/>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="memberdetail-content">

                        <div className="member-profile-header"
                             style={{
                                 backgroundImage: `url(${this.state.coverUrl || `${getApiUrl()}imageout/null/fallback.jpg?width=1920&height=600`})`
                             }}
                        >
                            <div className="member-profile-header-overlay"></div>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-xs-12">
                                        <div className="member-profile-image">
                                            {this.state.logoLoading ? (
                                                <div style={{width: '240px', height: '240px', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'transparent', borderRadius: '50%'}}>
                                                    <span></span>
                                                </div>
                                            ) : (
                                                <img
                                                    src={this.state.logoUrl}
                                                    className={`member-logo-image ${this.state.logoImageLoaded ? 'loaded' : ''}`}
                                                    onLoad={() => this.setState({ logoImageLoaded: true })}
                                                    loading="lazy"
                                                    width="240" height="240" alt={member.member_post_title}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="member-profile-section-1">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-xs-12 col-md-6 col-lg-4">
                                        <h1 dangerouslySetInnerHTML={{__html: member.member_post_title}}/>
                                        <h2 dangerouslySetInnerHTML={{__html: member.member_tagline2}}/>
                                    </div>
                                    <div className="col-xs-12 col-md-6 col-lg-3">
                                        <div className="member-profile-header-buttons-dep">
                                            <ul>
                                                {this.renderCategories(categories)}
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-md-12 col-lg-5">
                                        <div className="member-profile-header-tabs">
                                            <ul>
                                                <li className={(this.state.activeView === VIEW_LETTER_A) ? 'active' : ''}>
                                                    <a href="#!"
                                                       onClick={(event) => this.handleChangeView(event, VIEW_LETTER_A)}>Klinik
                                                        bzw. Praxis</a>
                                                </li>
                                                {
                                                    (this.state.layers.secondLayer.length > 0)
                                                    ? <li className={(this.state.activeView === VIEW_LETTER_B) ? 'active' : ''}>
                                                            <a href="#!"
                                                               onClick={(event) => this.handleChangeView(event, VIEW_LETTER_B)}>Über
                                                                den Arzt</a>
                                                        </li>
                                                    : <Fragment />

                                                }

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="memberlist-content">
                            <div className="container-fluid">

                                {
                                    (this.state.activeView === VIEW_LETTER_A)
                                        ?
                                        <Fragment>
                                            <div className="mansory-container">

                                                <div className="member-profile-card">
                                                    <div className="member-profile-card-head">
                                                        <div className="member-profile-card-title">
                                                            <h5>Kontakt</h5>
                                                        </div>
                                                    </div>
                                                    <div className="member-profile-card-body">
                                                        <table className="table profile-table">
                                                            {
                                                                (member.member_location)
                                                                    ?
                                                                    <tr>
                                                                        <td width="30"><i className="fa fa-map"></i>
                                                                        </td>
                                                                        <td><a
                                                                            href={'https://www.google.com/maps/place/' + member.member_location + '/'}
                                                                            target={'_blank'}
                                                                            rel="noreferrer"
                                                                        >{member.member_location}</a></td>
                                                                    </tr>
                                                                    :
                                                                    <Fragment/>
                                                            }
                                                            {
                                                                (member.member_email)
                                                                    ?
                                                                    <tr>
                                                                        <td width="30"><i
                                                                            className="fa fa-envelope"></i>
                                                                        </td>
                                                                        <td><a
                                                                            href={'mailto:' + member.member_email}>{member.member_email}</a>
                                                                        </td>
                                                                    </tr>
                                                                    :
                                                                    <Fragment/>
                                                            }
                                                            {
                                                                (member.member_phone)
                                                                    ?
                                                                    <tr>
                                                                        <td width="30"><i
                                                                            className="fa fa-phone"></i></td>
                                                                        <td><a
                                                                            href={'tel:' + member.member_phone}>{member.member_phone}</a>
                                                                        </td>
                                                                    </tr>
                                                                    :
                                                                    <Fragment/>
                                                            }
                                                            {
                                                                (member.member_website)
                                                                    ?
                                                                    <tr>
                                                                        <td width="30"><i
                                                                            className="fa fa-globe"></i></td>
                                                                        <td><a href={member.member_website}
                                                                               rel="noreferrer" target={'_blank'}>Zur
                                                                            Website</a></td>
                                                                    </tr>
                                                                    :
                                                                    <Fragment/>
                                                            }

                                                        </table>
                                                    </div>
                                                </div>

                                                {
                                                    this.state.layers.firstLayer.map(layerItem => {
                                                        return (
                                                            <div className="member-profile-card">
                                                                <div className="member-profile-card-head">
                                                                    <div className="member-profile-card-title">
                                                                        <h5>{layerItem.title}</h5>
                                                                    </div>
                                                                </div>
                                                                <div className="member-profile-card-body">
                                                                    {
                                                                        (layerItem.direct === true)
                                                                        ? <Fragment>{layerItem.content}</Fragment>
                                                                        : <div
                                                                                className="table profile-table"
                                                                                dangerouslySetInnerHTML={{__html: layerItem.content}}/>
                                                                    }
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }


                                                <div className="member-profile-card">
                                                    <div className="member-profile-card-head">
                                                        <div className="member-profile-card-title">
                                                            <h5>Anfahrt</h5>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="member-profile-card-body member-profile-card-body-fix-padding member-profile-card-body-map">

                                                        <form onSubmit={this.handleDirectionForm}>
                                                            <div className="container-fluid mb-20">
                                                                <div className="row">
                                                                    <div className="col-sm-8">
                                                                        <input
                                                                            type="text"
                                                                            name="origin"
                                                                            className="w-100"
                                                                            placeholder={'Ihre Adresse'}
                                                                        />
                                                                    </div>
                                                                    <div className="col-sm-4">
                                                                        <button type={'submit'}
                                                                                className="w-100">Route
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </form>

                                                        <div className="container-fluid">
                                                            <div className="row">
                                                                <div className="col-sm-12">

                                                                    <GoogleMap
                                                                        id={'gmap-memberdetail'}
                                                                        mapContainerStyle={{
                                                                            width: '100%',
                                                                            height: '400px'
                                                                        }}
                                                                        center={{
                                                                            lat: parseFloat(member.member_latitude),
                                                                            lng: parseFloat(member.member_longitude)
                                                                        }}
                                                                        zoom={10}
                                                                        onLoad={(map) => {
                                                                            this.setState({
                                                                                map
                                                                            })
                                                                        }}
                                                                        options={{
                                                                            // these following 7 options turn certain controls off see link below
                                                                            streetViewControl: false,
                                                                            scaleControl: false,
                                                                            mapTypeControl: false,
                                                                            panControl: false,
                                                                            zoomControl: true,
                                                                            rotateControl: false,
                                                                            fullscreenControl: false
                                                                        }}
                                                                    >

                                                                        <Marker
                                                                            key={member.member_id}
                                                                            position={{
                                                                                lat: parseFloat(member.member_latitude),
                                                                                lng: parseFloat(member.member_longitude)
                                                                            }}
                                                                            title={member.post_title}
                                                                            id={'ABC'}
                                                                            /*
                                                                            icon={{
                                                                                url: getLiveApiUrl() + 'imageout/' + member.profileimage_id + '?width=50&height=50',
                                                                                optimized: false
                                                                            }}
                                                                             */
                                                                        >
                                                                        </Marker>
                                                                    </GoogleMap>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                {
                                                    (member.member_treatment_focus && stripHtml(member.member_treatment_focus).trim().length > 8)
                                                        ?
                                                        <div className="member-profile-card">
                                                            <div className="member-profile-card-head">
                                                                <div className="member-profile-card-title">
                                                                    <h5>Behandlungsschwerpunkte</h5>
                                                                </div>
                                                            </div>
                                                            <div className="member-profile-card-body">
                                                                <div
                                                                    dangerouslySetInnerHTML={{__html: member.member_treatment_focus}}/>
                                                            </div>
                                                        </div>
                                                        :
                                                        <Fragment/>
                                                }

                                                {
                                                    (member.member_therapeutic_services && stripHtml(member.member_therapeutic_services).trim().length > 8)
                                                        ?
                                                        <div className="member-profile-card">
                                                            <div className="member-profile-card-head">
                                                                <div className="member-profile-card-title">
                                                                    <h5>Therapeutische Leistungen</h5>
                                                                </div>
                                                            </div>
                                                            <div className="member-profile-card-body">
                                                                <div
                                                                    dangerouslySetInnerHTML={{__html: member.member_therapeutic_services}}/>
                                                            </div>
                                                        </div>
                                                        :
                                                        <Fragment/>
                                                }


                                            </div>
                                        </Fragment>
                                        :
                                        <Fragment>

                                            <div className="mansory-container">

                                                {
                                                    this.state.layers.secondLayer.map((layerItem, index) => {
                                                        return (
                                                            <div ref={layerItem.reference} className={'member-profile-card ' + (typeof(layerItem.accordion) !== "undefined" ? ' member-profile-card-accordion ' : '') + ' ' + (this.state.accordion.secondLayer.includes(index) ? ' member-profile-card-long' : '')}>
                                                                <div className="member-profile-card-head">
                                                                    <div className="member-profile-card-title">
                                                                        <h5>{layerItem.title}</h5>
                                                                    </div>
                                                                </div>
                                                                <div className="member-profile-card-body">
                                                                    <div
                                                                        className="table profile-table member_long_card"
                                                                        dangerouslySetInnerHTML={{__html: layerItem.content}}/>
                                                                </div>
                                                                {
                                                                    (this.state.accordion.secondLayer.includes(index))
                                                                        ? <a href="#!" className="btn-link readmore" onClick={(e) => this.showLess(e, 'secondLayer', index)}>Weniger anzeigen</a>
                                                                        : <a href="#!" className="btn-link readmore" onClick={(e) => this.showMore(e, 'secondLayer', index)}>Mehr anzeigen</a>
                                                                }
                                                            </div>
                                                        )
                                                    })
                                                }


                                            </div>

                                        </Fragment>
                                }


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default MemberDetail;
